<template>
  <div class="about-page-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <span>关于我们</span>
      </div>
    </div>

    <!-- 公司简介 -->
    <section class="company-intro-section">
      <div class="container-fixed flex-between intro-content">
        <div class="intro-text">
          <div class="section-header-left">
            <h1 class="cn-title">{{ info.msg.webContentTitle }}</h1>
            <p class="en-title">Brief Introduction</p>
          </div>
          <div class="content-body" v-html="info.msg.webContentText"></div>
        </div>
        <div class="intro-image card-modern">
          <img
            src="https://img.js.design/assets/img/613eaa7ba9696d53260506a9.png"
            alt="公司简介图片"
          />
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="container-fixed">
        <div class="section-header">
          <div class="en-title">CONTACT US</div>
          <div class="cn-title">联系我们</div>
        </div>

        <div class="contact-grid">
          <div class="contact-details card-modern">
            <div class="contact-item">
              <i class="el-icon-phone"></i>
              <div class="item-info">
                <label>{{ info.phone.webContentTitle }}</label>
                <span>{{ info.phone.webContentText }}</span>
                <span>{{ info.mobile.webContentText }}</span>
                <span>{{ info.mobile2.webContentText }}</span>
              </div>
            </div>
            <div class="contact-item">
              <i class="el-icon-location-outline"></i>
              <div class="item-info">
                <label>联系地址</label>
                <p>
                  {{ info.address.webContentTitle
                  }}{{ info.address.webContentText }}
                </p>
                <p>
                  {{ info.address2.webContentTitle
                  }}{{ info.address2.webContentText }}
                </p>
              </div>
            </div>
            <div class="contact-item">
              <i class="el-icon-message"></i>
              <div class="item-info">
                <label>{{ info.Email.webContentTitle }}</label>
                <span>{{ info.Email.webContentText }}</span>
              </div>
            </div>
          </div>

          <div
            class="contact-qr card-modern"
            v-for="(item, index) in imgList"
            :key="index"
          >
            <img :src="item.picLoad" :alt="item.title" />
            <span>{{ item.title }}</span>
          </div>
        </div>

        <div class="maps-container">
          <Mapview class="map-item card-modern"></Mapview>
          <Mapview2 class="map-item card-modern"></Mapview2>
        </div>
      </div>
    </section>

    <!-- 资质中心 -->
    <section class="aptitude-section">
      <div class="container-fixed">
        <div class="section-header">
          <div class="en-title">QUALIFICATIONS</div>
          <div class="cn-title">资质中心</div>
        </div>

        <div class="aptitude-grid">
          <div
            class="aptitude-card card-modern"
            v-for="(item, index) in aptitudeList"
            :key="index"
          >
            <div class="aptitude-img-box">
              <el-image
                :src="item"
                :preview-src-list="aptitudeList"
                fit="contain"
              />
            </div>
            <div class="aptitude-title">
              {{
                index == 0 ? "营业执照" : index == 1 ? "西部CA授权" : "签章授权"
              }}
            </div>
          </div>
        </div>

        <div class="external-link-box">
          <div
            class="link-card"
            @click="
              junpOpen(
                'https://cwca.aisino.com/387239352241233327.html?no=005b05e033430e1388',
              )
            "
          >
            <i class="el-icon-link"></i>
            <span>西部CA友情展示链接</span>
            <p>
              https://cwca.aisino.com/387239352241233327.html?no=005b05e033430e1388
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import article from "@/api/article";
import Mapview from "@/components/MapContainer.vue";
import Mapview2 from "@/components/MapContainers.vue";

let aptitudeImg1 = require("../assets/images/营业执照.jpg");
let aptitudeImg2 = require("../assets/images/西部ca授权.jpg");
let aptitudeImg3 = require("../assets/images/签章授权.jpg");

export default {
  name: "AboutUs",
  components: {
    Banner,
    Mapview,
    Mapview2,
  },
  data() {
    return {
      Img1: require("../assets/images/bannerabout.png"),
      aptitudeList: [aptitudeImg1, aptitudeImg2, aptitudeImg3],
      imgList: [],
      info: {
        address: { webContentText: "", webContentTitle: "" },
        address2: { webContentText: "", webContentTitle: "" },
        phone: { webContentText: "", webContentTitle: "" },
        msg: { webContentText: "", webContentTitle: "" },
        mobile: { webContentText: "", webContentTitle: "" },
        mobile2: { webContentText: "", webContentTitle: "" },
        Email: { webContentText: "", webContentTitle: "" },
      },
      loading: false,
    };
  },
  mounted() {
    this.handleGetData();
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      article.bannerList({ belongPage: "foot" }).then((res) => {
        this.imgList = res.data.data.records.slice(2, 3);
      });
    },
    handleGetData() {
      this.loading = true;
      article
        .aboutData({ belongPage: "about" })
        .then((res) => {
          const records = res.data.data.records;
          records.forEach((item) => {
            if (
              [
                "Email",
                "locahost",
                "phone",
                "mobile",
                "mobile2",
                "address2",
                "address",
                "connect",
              ].includes(item.notes)
            ) {
              item.webContentText = item.webContentText.replace(/<[^>]*>/g, "");
            }
            this.info[item.notes] = item;
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    junpOpen(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables.less";

.about-page-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

/* 公司简介 */
.company-intro-section {
  padding: 60px 0;
  background-color: @bg-white;
  background-image: url("../assets/img/蒙版.png");
  background-size: cover;
}

.intro-content {
  gap: 60px;
}

.intro-text {
  flex: 1;
  .section-header-left {
    margin-bottom: 32px;
    .cn-title {
      font-size: 32px;
      color: @primary-color;
      font-weight: 700;
      margin-bottom: 8px;
    }
    .en-title {
      font-size: 14px;
      color: @text-muted;
      text-transform: uppercase;
      letter-spacing: 1px;
    }
  }
  .content-body {
    font-size: 16px;
    line-height: 1.8;
    color: @text-secondary;
    text-align: justify;
  }
}

.intro-image {
  width: 480px;
  height: 520px;
  padding: 12px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
}

/* 联系我们 */
.contact-section {
  padding: 80px 0;
}

.contact-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: @space-lg;
  margin-bottom: @space-xl;
}

.contact-details {
  padding: @space-xl;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .contact-item {
    display: flex;
    gap: 20px;
    i {
      font-size: 28px;
      color: @primary-color;
      margin-top: 4px;
    }
    .item-info {
      label {
        display: block;
        font-size: 16px;
        font-weight: 700;
        color: @text-main;
        margin-bottom: 8px;
      }
      span,
      p {
        font-size: 15px;
        color: @text-secondary;
        margin-right: 12px;
        line-height: 1.6;
      }
    }
  }
}

.contact-qr {
  padding: @space-xl;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  img {
    width: 300px;
    height: 300px;
    padding: 8px;
    background: #fff;
    border: 1px solid @border-color;
    transition: all 0.5s;
  }
  span {
    font-size: 14px;
    color: @text-secondary;
    font-weight: 500;
  }
}

.maps-container {
  display: flex;
  gap: @space-lg;
  height: 400px;
  .map-item {
    flex: 1;
    overflow: hidden;
  }
}

/* 资质中心 */
.aptitude-section {
  padding: 80px 0;
  background-color: @bg-white;
}

.aptitude-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: @space-lg;
  margin-bottom: @space-xl;
}

.aptitude-card {
  padding: @space-md;
  text-align: center;
  .aptitude-img-box {
    height: 280px;
    margin-bottom: 16px;
    background: @bg-base;
    border-radius: 4px;
    padding: 20px;
    /deep/ .el-image {
      width: 100%;
      height: 100%;
    }
  }
  .aptitude-title {
    font-size: 16px;
    font-weight: 600;
    color: @text-main;
  }
}

.external-link-box {
  .link-card {
    background: @primary-light;
    border: 1px dashed @primary-color;
    border-radius: @border-radius;
    padding: 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: #e0f2ff;
      transform: translateY(-2px);
    }

    i {
      font-size: 24px;
      color: @primary-color;
      margin-bottom: 12px;
    }
    span {
      display: block;
      font-size: 16px;
      font-weight: 600;
      color: @primary-color;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: @text-secondary;
      word-break: break-all;
    }
  }
}

@media (max-width: 992px) {
  .intro-content,
  .contact-grid,
  .aptitude-grid,
  .maps-container {
    grid-template-columns: 1fr;
    flex-direction: column;
  }
  .intro-image {
    width: 100%;
    height: auto;
  }
  .maps-container {
    height: auto;
    .map-item {
      height: 300px;
    }
  }
}
</style>
